import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { Mail, LinkedIn, Facebook, Instagram, Twitter } from '../../assets/svg/icons'
import { MemberSocialContainer } from '../../styles/teamStyles'

const MemberSocial = ({ social }) => {

  const icons = (item) => {
    switch(item){
      case 'facebook':
        return Facebook
      case 'twitter':
        return Twitter
      case 'linkedin':
        return LinkedIn
      case 'instagram':
        return Instagram
      default:
        return Mail
    }
  }
  
  return (
    <MemberSocialContainer>
      {Object.entries(social).map(([type, url]) => url && <a key={type} href={`${type === 'email' ? 'mailto:' : ''}${url}`} className={type} target='_blank' rel='noopener noreferrer'>{React.createElement(icons(type))}</a>)}
    </MemberSocialContainer>
  )
}

MemberSocial.propTypes = {
  social: PropTypes.object.isRequired
}

export default memo(MemberSocial)
